import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { TSvgTypes } from '@r1-frontend/ui-react/components/svg/TSvgTypes';

import * as S from './styled';

export type TSvgSizeProps = {
    size: number,
    width?: never,
    height?: never,
} | {
    size?: never,
    width: number,
    height: number,
} | {
    size?: never,
    width?: never,
    height?: never,
}


export type TBaseSvgProps = {
    id: string,
    viewBox: string,
    role?: string,
    type?: TSvgTypes,
    strokeWidth?: number,
    children?: ReactNode,
    onClick?: () => void,
} & TSvgSizeProps;

const Svg = ({ role = 'img', type = 'info', size = 24, width, height, ...props }: TBaseSvgProps): JSX.Element => {
    if (!width && !height) {
        width = size;
        height = size;
    }

    return (
        <S.Svg
            xmlns='http://www.w3.org/2000/svg'
            role={role}
            type={type}
            width={width}
            height={height}
            {...props}
        />
    );
};

export default styled(Svg)``;
